export const stylesRefs = {
  sticky: 'DataTable_sticky',
  gridHeader: 'DataTable_gridHeader',
  grid: 'DataTable_grid',
  header: 'DataTable_header',
  loader: 'DataTable_loader',
} as const
